/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  var MAIN = {};

  MAIN.setFallback = function () {
    if (!feature.svg) {
      $('img').each(function () {
        $(this).attr('src', $(this).attr('src').replace(/\.svg/gi, '.png'));
      });
    }

    if (!feature.srcset) {
      $('body').addClass('no-srcset');
    }
  };

  MAIN.setIas = function () {
    var ias = $.ias({
      container: '.ias-container > .row',
      item: '.ias-item',
      pagination: '.posts-navigation',
      next: '.nav-previous > a',
      negativeMargin: 600
    });

    ias.extension(new IASSpinnerExtension({
      src: '/assets/images/spinner.svg'
    }));

    ias.extension(new IASTriggerExtension({
      text: 'More'
    }));
  };

  MAIN.setMenu = function () {
    $('.icon-menu').on('click', function () {
      $('.bar, .nav-primary-alt').toggleClass('active');
      return false;
    });
  };

  MAIN.setSearch = function () {
    $("#search-form-text").on('focus', function () {
      $(this).parent('label').addClass('active');
    });
    $("#search-form-text").on('blur', function () {
      if ($(this).val().length === 0) {
        $(this).parent('label').removeClass('active');
      }
    });
  };

  MAIN.setZoomJs = function () {
    var img = $('img.wp-media');
    img.each(function () {
      if (!$(this).parents('a').length) {
        $(this).attr('data-action', 'zoom');
      }
    });
  };

  MAIN.setExternalLink = function () {
    $('a').filter(function () {
      return this.hostname !== window.location.hostname;
    }).attr('target', '_blank');
  };

  MAIN.setPageScroll = function () {
    $('a[href^="#"]').not('.icon-menu').click(function () {
      var speed = 500;
      var offsetY = -70;
      var href = $(this).attr('href');
      var target = $(href === '#' || href === '' ? 'html' : href);
      var position = target.offset().top + offsetY;
      $('html, body').animate({ scrollTop: position }, speed, 'swing');
      return false;
    });
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var NEWREEL = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
        MAIN.setFallback();
        MAIN.setMenu();
        MAIN.setSearch();
        MAIN.setZoomJs();
        MAIN.setExternalLink();
        MAIN.setPageScroll();
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        MAIN.setIas();
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    },
    'post_type_archive': {
      finalize: function () {
        //MAIN.setIas();
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = NEWREEL;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
